import { useState, useEffect, useCallback } from "react";
import { fetchAPI } from '@/api';
import { useOutletContext } from 'react-router-dom';
import { OutletContext } from '@/types';

export const useFetch = <T,>(url: string, params?: T) => {
    const { auth } = useOutletContext<OutletContext>();

    const [data, setData] = useState<T | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await fetchAPI(url, auth.user.token, params);
            if (!response.ok) throw new Error(`This is an HTTP error: The status is ${response.status}`);
            const json = (await response.json()) as T;
            setData(json);
            setError(null);
        } catch (error: any) {
            let errorMessage = 'An unexpected error occurred';
            if (error.response?.message && error.name !== "AbortError") {
                errorMessage = error.response.message;
            }
            setError(errorMessage);
        } finally {
            setIsLoading(false);
        }
    }, [url, params]);

    const callFetch = () => {
        fetchData();
    };

    return { data, isLoading, error, callFetch };
};
